/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskPriority } from './TaskPriority';
import {
    TaskPriorityFromJSON,
    TaskPriorityFromJSONTyped,
    TaskPriorityToJSON,
    TaskPriorityToJSONTyped,
} from './TaskPriority';

/**
 * Request to create a new task
 * @export
 * @interface CreateClaimTaskRequest
 */
export interface CreateClaimTaskRequest {
    /**
     * Task title
     * @type {string}
     * @memberof CreateClaimTaskRequest
     */
    title: string;
    /**
     * Optional task description
     * @type {string}
     * @memberof CreateClaimTaskRequest
     */
    description?: string | null;
    /**
     * 
     * @type {TaskPriority}
     * @memberof CreateClaimTaskRequest
     */
    priority?: TaskPriority;
    /**
     * Optional due date for the task
     * @type {Date}
     * @memberof CreateClaimTaskRequest
     */
    dueDate?: Date | null;
    /**
     * ID of the user to assign this task to
     * @type {number}
     * @memberof CreateClaimTaskRequest
     */
    assignedTo?: number | null;
}



/**
 * Check if a given object implements the CreateClaimTaskRequest interface.
 */
export function instanceOfCreateClaimTaskRequest(value: object): value is CreateClaimTaskRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function CreateClaimTaskRequestFromJSON(json: any): CreateClaimTaskRequest {
    return CreateClaimTaskRequestFromJSONTyped(json, false);
}

export function CreateClaimTaskRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClaimTaskRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'priority': json['priority'] == null ? undefined : TaskPriorityFromJSON(json['priority']),
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
    };
}

export function CreateClaimTaskRequestToJSON(json: any): CreateClaimTaskRequest {
    return CreateClaimTaskRequestToJSONTyped(json, false);
}

export function CreateClaimTaskRequestToJSONTyped(value?: CreateClaimTaskRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'priority': TaskPriorityToJSON(value['priority']),
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate'] as any).toISOString()),
        'assignedTo': value['assignedTo'],
    };
}

